import { resolveMediaUrl } from './mediaHelpers';

const img = (path) => `${process.env.PUBLIC_URL}/assets/images/${path}`;

const PNG_LOGO_PATHS = {
  'partner/clients/aramco.svg': 'partner/clients/aramco.png',
  'partner/clients/sabic.svg': 'partner/clients/sabic.png',
  'partner/clients/samsung.svg': 'partner/clients/samsung.png',
  'partner/clients/maaden.svg': 'partner/clients/maaden.png',
  'partner/clients/sec.svg': 'partner/clients/sec.png',
  'partner/clients/petro-rabigh.svg': 'partner/clients/petro-rabigh.png',
  'partner/clients/acwa-power.svg': 'partner/clients/acwa-power.png',
  'partner/clients/slb.svg': 'partner/clients/slb.png',
};

export const resolveClientLogoPath = (path) => {
  if (!path) return null;
  const normalized = path.replace(/^\//, '');
  if (PNG_LOGO_PATHS[normalized]) return PNG_LOGO_PATHS[normalized];
  if (/\.svg$/i.test(normalized)) {
    const pngCandidate = normalized.replace(/\.svg$/i, '.png');
    return pngCandidate;
  }
  return normalized;
};

export const clientLogoUrl = (path) => {
  const resolved = resolveClientLogoPath(path);
  return resolved ? img(resolved) : null;
};

export const mapClientLogo = (client) => {
  const uploadedLogo = resolveMediaUrl(client.logo);
  const pathLogo = client.logoPath ? clientLogoUrl(client.logoPath) : null;

  return {
    id: client.documentId,
    name: client.name,
    url: client.websiteUrl || '#',
    logo: uploadedLogo || pathLogo,
  };
};
